/* Logo-Zwinkern: entscheidet nur, WANN die Animation laeuft.
   Einmal pro Besuch, nicht bei jedem Seitenwechsel -- sonst zwinkert das
   Logo bei jedem Klick durch den Shop. sessionStorage haelt genau eine
   Sitzung, Tab zu heisst beim naechsten Besuch wieder einmal. */
(function () {
  var KEY = 'amv2WinkShown';
  var el = document.querySelector('[data-amv2-wink]');
  if (!el) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  try { if (sessionStorage.getItem(KEY)) return; } catch (e) { /* privater Modus */ }

  function start() {
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    setTimeout(function () { el.classList.add('is-winking'); }, 900);
  }
  /* Erst starten, wenn die Schrift steht -- sonst zuckt das Logo beim
     ersten Aufbau, weil sich die Breite von "AUGEN" noch aendert. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(start).catch(start);
  } else {
    window.addEventListener('load', start);
  }
})();